import { ConfirmDialogParams } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

export class MarkAsSignedConfirmDialogParams extends ConfirmDialogParams {
  constructor() {
    super(`Have you received the signed agreement?`, `Make sure you have the signed agreement file before marking as signed.`, `Mark as Signed`);
  }
}
